// extracted by mini-css-extract-plugin
export default {"container":"SideNavigation_container__fKFAm","open":"SideNavigation_open__i+DqD","tab":"SideNavigation_tab__V9Eg7","active":"SideNavigation_active__aNeiY"};